import { Injectable } from "@angular/core";
import { Validators } from "@angular/forms";

@Injectable({
    providedIn: 'root'
})
export class SpecificationsActionsValidator {

    field = [
        Validators.required
    ];
    format = [
        Validators.required
    ]
    lang = [
        Validators.required
    ]
    type = [
        Validators.required
    ];
    requirement = [
        Validators.required
    ]

    // Error messages
    errorMessages = {

        field: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        format: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        lang: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        type: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ],
        requirement: [
            {
                type: 'required',
                message: 'MESSAGES.REQUIRED_FIELD',
                options: null
            }
        ]
    }
}